import React from "react";

export const menu = React.lazy(() =>
  import("../scenes/global/MobilePages/Menu/Menu")
);
export const mobileNotifcation = React.lazy(() =>
  import("../scenes/global/MobilePages/Notifcation/MobileNotifcation")
);